// extracted by mini-css-extract-plugin
module.exports = {"container":"AppFootnote_container__wmA9J","title":"AppFootnote_title__XEOoG","content":"AppFootnote_content__s_XDj"};